import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class NavbarSettingsService extends Service {
  @tracked title = '';

  // List of menu items to show
  // [{ label: '', route: 'route name' }]
  menuItems = [];

  @tracked topNavbarComponent = '';

  @tracked currentMenuLabel = 'rootMenu';
  @tracked rootMenuLabel = 'rootMenu';

  @tracked showActiveJournalButton = false;

  // if set, then will show an import button in the top header
  @tracked importButtonRoute?: string;

  resetCurrentMenuLabel() {
    this.currentMenuLabel = this.rootMenuLabel;
  }

  @tracked enableFluidContainer = false;
}
